import type { Customer } from '@brighterly/lib-core-types/customer/interfaces'
import type { KidInCustomer } from '@brighterly/lib-core-types/kid/interfaces'

import { Discipline } from '@brighterly/lib-core-types/discipline/enums'

export const getHomeDisciplineCode = (kid: KidInCustomer | null): Discipline => {
  const disciplines: Discipline[] = (kid?.disciplines || []).map(disciplineInKid => disciplineInKid.code)

  return disciplines.includes(Discipline.ELA) && !disciplines.includes(Discipline.Math)
    ? Discipline.ELA
    : Discipline.Math
}

export const getHomePageRoute = (customer: Customer): string | null => {
  const kid: KidInCustomer | null = customer?.kids?.[0] || null
  const kidId: number | null = kid?.id || null
  const disciplineRoute = getHomeDisciplineCode(kid).toLowerCase()

  return kidId ? `/kids/${kidId}/${disciplineRoute}` : null
}
